import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {getKindsBoatsInputs,headerName} from "./constantsKindsBoatsModal";
import {
    createKindBoat,
    updateKindBoat
} from "../../../../../redux/directoryMaintenance/kindsBoatsReducer/actionKindsBoats";
import UniversalModal from "../../universalModal";

function KindsBoatsModal({ setShow, show, type, setSave }) {
    const dispatch = useDispatch();

    const [fields, setFields] = useState([]);
    const [initialFieldsData, setInitialFieldsData] = useState({});

    const kindBoat = useSelector((state) => {
        const { kindsBoatsReducer } = state;
        return kindsBoatsReducer.kindBoat;
    });
    async function setParamsForOptions() {
        setFields(Object.values(getKindsBoatsInputs()));
    }
    const handleSaveClick = async (data) => {
        if (type === "add") {
            dispatch(createKindBoat({...data}))
        }
        if (type === "edit") {
            dispatch(updateKindBoat(kindBoat.id,{...data}))
        }
        setSave();
        setShow(false);
    }
    useEffect(() => {
        setParamsForOptions().then();
    }, []);
    useEffect(() => {
        const initialData = {};
        fields.forEach((field) => {
            initialData[field.key] = field.type === "text" ? "" : null;
        });
        setInitialFieldsData(initialData);
    }, [fields]);


    return (
        <UniversalModal
            show={show}
            onHide={() => setShow(false)}
            onSave={(data) => handleSaveClick(data)}
            fields={fields}
            initialFieldsData={initialFieldsData}
            initialData={kindBoat}
            eaderName={headerName[type]}
            type={type}
        />
    );
}

export default KindsBoatsModal;